"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDTO = void 0;
class UserDTO {
    id;
    name;
    contacts;
    conversations;
    lastName;
    email;
    document;
    password;
    phone;
    roles;
    avatar;
    files;
    birthDate;
    createdAt;
    master;
}
exports.UserDTO = UserDTO;
